// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__YNNtG","name":"Header_name__1ix8K","birthday":"Header_birthday__3XUGL","skeleton":"Header_skeleton__2ITuR"};